export default "__VITE_ASSET__6OgLHX6B__"